import * as React from "react";

import { Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";

import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const FbwA32NxChecklistMarketingSeo = () => <FbwA32NxMarketingSeo simplified />;
export const FbwA32NxExpandedMarketingSeo = () => <FbwA32NxMarketingSeo simplified={false} />;

const FbwA32NxMarketingSeo = ({ simplified }: { simplified: boolean }): JSX.Element => {
  const docsLabel = simplified ? "checklist" : "normal operating procedures";
  const linkDirection = simplified ? "an expanded" : "a simplified";
  const linkTitle = simplified
    ? "expanded normal operating procedures template"
    : "simplified checklist template";
  const linkHref = simplified
    ? "/templates/aircraft/fbw-a32nx-expanded"
    : "/templates/aircraft/fbw-a32nx";

  return (
    <Stack>
      <SeoSection title="An open-source treasure">
        <Text fz="medium">
          The FlyByWire A32NX upgrades the realism and accuracy of the default MSFS A320neo. No more
          "inop" buttons or switches -- the FBW A320 brings a faithful simulation to almost every
          function found in the real aircraft. This template is a recreation of the{" "}
          <a href="https://docs.flybywiresim.com/pilots-corner/SOP/" target="_blank">
            {docsLabel} in the FBW docs
          </a>{" "}
          for your convenience. For {linkDirection} version of this template, see the{" "}
          <Link to={linkHref}>{linkTitle}</Link>.
        </Text>
      </SeoSection>
      <SeoSection title="Make the A32NX your own">
        <Text fz="medium">
          You can customize this checklist to your liking using the web-based editor. Change colors
          and font sizes. Add memory items that need reinforcement, or mix in reminders for your
          favorite addon software. Checklists can be exported as PDFs and are saved in your browser,
          so you can come back and adjust them later.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
